import React from "react";
import styles from './ResponsiveTable.module.css';
import CGCimage from "../../assets/CGC-image.png";
import JustImg from "../../assets/JustImg.png";
import AiubImg from "../../assets/AiubImg.png";
import UsguImg from "../../assets/UsguImg.png";

const data = [
  { id: 1, university: 'Jamhuriya University of Science and Technology', country: 'Somalia', 'image' : JustImg },
  { id: 2, university: 'American International University-Bangladesh (AIUB)', country: 'Bangladesh', 'image' : AiubImg },
  { id: 3, university: 'United States Global University (USGU)', country: 'USA', 'image' : UsguImg },
];

function Partners() {
  return (
    <div>
      <div className="flex flex-col md:flex-row items-center justify-center mt-10 p-4">
        <div className="md:w-2/3 mt-5">
          <div className={styles.tableContainer}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>University</th>
                  <th>Country</th>
                  <th>Logo</th>
                </tr>
              </thead>
              <tbody>
                {data.map(item => (
                  <tr key={item.id}>
                    <td data-label="id">{item.id}</td>
                    <td data-label="University">{item.university}</td>
                    <td data-label="country">{item.country}</td>
                    <td data-label="logo"><img src={item.image} alt={item.university} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Partners;
